<template>
	<section class="page">
		<due-tabs v-model="activeName"></due-tabs>
		<div class="content-box">
			<fast-edit-order></fast-edit-order>
		</div>
	</section>
</template>

<script>
import FastEditOrder from "@/views/Order/subs/FastEditOrder.vue";
import TabPage from "@/mixins/TabPage.js";
import DueTabs from "@/views/Order/widgets/DueTabs.vue";

export default {
	mixins: [TabPage],
	components: {
		FastEditOrder,
		DueTabs,
	},
	data() {
		return {
			activeName: "build",
			fakeTabs: {
				indexs: { name: "Order-Index" },
				waitpay: { name: "Order-WaitPay" },
				due: { name: "Order-IndexDue" },
			},
		};
	},
};
</script>
<style lang="scss" scoped>
</style>
